export const INSERT_LUNCH_MENU_MUTATION = `
  mutation InsertLunchMenu($input: LunchMenuInsertInput!) {
    insertLunchMenu(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_LUNCH_MENU_MUTATION = `
  mutation UpdateLunchMenu($filter: String!, $input: LunchMenuUpdateInput!) {
    updateLunchMenu(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_LUNCH_MENU_MUTATION = `
  mutation DeleteLunchMenu($filter: String!, $input: LunchMenuDeleteInput!) {
    deleteLunchMenu(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;
